var map = {
	"./arrow-down.svg": "l5rq",
	"./arrow-down2.svg": "cUun",
	"./contact-circleblue.svg": "ERDc",
	"./contact-circlered.svg": "NBfZ",
	"./contact-illu.svg": "0xaz",
	"./contact-pattern.svg": "xC3B",
	"./cylinder1.svg": "/0ie",
	"./demi-sphere1.svg": "lmLx",
	"./disk-pattern1.svg": "XJgm",
	"./dots-pattern-left.png": "+VvE",
	"./dots-pattern-left.svg": "LOUk",
	"./dots-pattern-right.png": "UG5x",
	"./dots-pattern-right.svg": "Skaf",
	"./favicon.png": "Yhqy",
	"./gatsby-astronaut.png": "qRbu",
	"./gatsby-icon.png": "waaq",
	"./hero-disks.svg": "rQTG",
	"./hero-illustration.svg": "rZqd",
	"./hero-illustration2.png": "5vKp",
	"./icon-build.svg": "UGGI",
	"./icon-design.svg": "CmdV",
	"./icon-discovery.svg": "XgUR",
	"./icon-launch.svg": "wbtk",
	"./icon-send.svg": "9Msc",
	"./icon-slackforward.svg": "BdFm",
	"./icon-usurpid.svg": "lcmN",
	"./icon-wtrackr.svg": "mfZl",
	"./illustration.png": "gaev",
	"./itsalive-cover.png": "rMeh",
	"./itsalive-logo.svg": "FMPg",
	"./kinesis-cover.png": "D1IN",
	"./kinesis-logo.svg": "xPOQ",
	"./logo-carrefour.svg": "hCRd",
	"./logo-coca.svg": "uMbv",
	"./logo-iwc.svg": "x5L4",
	"./logo-maif.svg": "qi2T",
	"./logo-veolia.svg": "YGm9",
	"./logo-viparis.svg": "89aV",
	"./loop-1.svg": "B3DW",
	"./loop-2.svg": "7xUJ",
	"./loop-3.svg": "OK2Y",
	"./loop-end.svg": "r4Qm",
	"./loop-start.svg": "tL4c",
	"./miciv-cover.png": "/bOf",
	"./miciv-logo.svg": "y0U1",
	"./pattern-dots-process.svg": "NARw",
	"./pattern-dots-products.svg": "t6Om",
	"./saastory-3D0008.png": "Z8Ar",
	"./saastory-illustration-3D.png": "zc7E",
	"./saastory-logo-dark.svg": "7x/2",
	"./saastory-logo.svg": "DDrq",
	"./saastory-og-cover.png": "1akZ",
	"./sent-cover.png": "rIl7",
	"./sent-logo.svg": "+dHk",
	"./service-cylinder.svg": "bBFs",
	"./service-demisphere.svg": "Ehp2",
	"./service-disk.svg": "ebuC",
	"./service-square.svg": "tjAN",
	"./sphere1.svg": "x4uW",
	"./square.png": "vCg7",
	"./square.svg": "WohH",
	"./square1.svg": "D5g/",
	"./steps-illustration.svg": "fDBF",
	"./timemachine-cover.png": "c0tr",
	"./timemachine-logo.svg": "4ziC",
	"./tweetit-cover.png": "2i59",
	"./tweetit-logo.svg": "hIQR"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "mFaS";